module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('clip-loader', {
    attrs: {
      "loading": _vm.loading,
      "color": "#337ab7"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32af4dfb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/Loader.vue
// module id = 1443
// module chunks = 1